import React from 'react';
import { HeroBanner } from 'src/components/Affiliate/HeroBanner';
import { HeroInfo } from 'src/components/Affiliate/HeroInfo';
import { SearchSection } from 'src/components/Affiliate/SearchSection';
import { SEO } from 'src/components/SEO/SEO';
import styles from './AffiliatesContainer.module.scss';

export const AffiliatesContainer: React.FC = () => {
	return (
		<>
			<SEO path={location.pathname} />
			<div className={styles.affiliatesWidthWrap}>
				<HeroBanner />
				<HeroInfo />
				<div className={styles.divider} data-title='Programs' id='program-cards'></div>
				<SearchSection />
			</div>
		</>
	);
};
